import { ContactArea, UserScope } from "@deliverr/business-types";

import { Role } from "./Role";
import { Source } from "./Source";

export interface User {
  readonly sellerId: string;
  readonly userId: string;
  readonly cognitoId?: string;
  readonly createdBy?: string;
  readonly email: string;
  readonly phoneNumber?: string;
  readonly role: Role;
  readonly entitiesAccessTo: string;
  readonly source: Source;
  readonly pendingInvite: boolean;
  readonly pendingInviteExpirationDate?: Date;
  readonly isArchived?: boolean;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly contactAreas?: ContactArea[];
  readonly userScopes?: UserScope[];
}

export interface PasswordExpirationInfo {
  shouldShowPasswordExpirationBanner: boolean;
  daysTillPasswordExpiration: number | null;
}

export const defaultPasswordExpirationInfo: PasswordExpirationInfo = {
  shouldShowPasswordExpirationBanner: false,
  daysTillPasswordExpiration: null,
};

export interface UserClientResponse extends PasswordExpirationInfo {
  sellerId: string | null;
  isOnWaitlist: boolean;
}

export const defaultUserClientResponse: UserClientResponse = {
  sellerId: null,
  isOnWaitlist: false,
  ...defaultPasswordExpirationInfo,
};
